import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { HeaderNew } from './components/Header/HeaderNew'
import { Categories } from './views/Categories'
import { Dashboard } from './views/Dashboard'
import { Emails } from './views/Emails'
import EventView from './views/EventView'
import HomeView from './views/HomeView'
import { Inscriptions } from './views/Inscriptions'
import LoginPage from './views/Login'
import { MyAccount } from './views/MyAccount'
import { SingleUser } from './views/SingleUser'
import { Statistics } from './views/Statistics'
import { UserStatistics } from './views/UserStatistics'
import { UserTable } from './views/UserTable'

import axios from 'axios'
import { useEffect, useState } from 'react'
import { constants } from './Constants'
import useAuth from './utils/useAuth'
import { ClassesCalendar } from './views/ClassesCalendar'
import { Comunications } from './views/Comunications'
import MockButtons from './views/MockButtons'
import MyCalendar from './views/MyCalendar'
import { Notifications } from './views/Notifications'
import Privacidad from './views/Privacidad'
import { Schedule } from './views/Schedule'
import { TableOfTrophy } from './views/TableOfTrophy'
import { Weather } from './views/Weather'

const PUBLIC_ROUTES = ['/privacidad']

// Estas páginas solo hacen llamadas a endpoints protegidos con isAdmin en el
// backend; sin este guard, un usuario normal podía entrar por URL directa y
// se encontraba la página cargada pero sin datos (403 silencioso).
const AdminRoute = ({ children }) => {
  const navigate = useNavigate()
  const localUser = JSON.parse(localStorage.getItem('user') || 'null')

  useEffect(() => {
    if (!localUser || localUser.role !== 'admin') {
      navigate('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!localUser || localUser.role !== 'admin') return null
  return children
}

function App() {
  const user = JSON.parse(localStorage.getItem('user'))
  const [dataUser, setDataUser] = useState()
  const location = useLocation()
  useAuth(user)
  const navigate = useNavigate()

  useEffect(() => {
    if (PUBLIC_ROUTES.includes(location.pathname)) return
    const verifyUser = async () => {
      if (user && user.id) {
        try {
          const response = await axios.get(
            `${constants.urlLocal}getUser/${user.id}`
          )
          setDataUser(response.data?.user)
          if (!response.data.ok) {
            localStorage.removeItem('user')
            navigate('/login')
          }
        } catch (error) {
          console.error('Error al verificar el usuario', error)
          if (
            error.response?.status === 404 &&
            error.response?.data?.ok === false
          ) {
            localStorage.removeItem('user')
            navigate('/login')
          }
        }

        const iosId = localStorage.getItem('iosId')
        if (!user.iosId && iosId) {
          axios
            .put(`${constants.urlLocal}update-ios-id`, {
              userId: user.id,
              iosId,
            })
            .then(() => {
              console.log('ID de iOS enviado al servidor')
            })
            .catch(error => {
              console.error('Error al enviar el ID de iOS al servidor:', error)
            })
        }
      } else if (!user || !user.id) {
        navigate('/login')
      }
    }
    verifyUser()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  return (
    <>
      <HeaderNew />
      <Routes>
        <Route path="/" element={<HomeView user={dataUser} />} />
        <Route path="/event/:id" element={<EventView />} />
        <Route path="/my-inscriptions" element={<Inscriptions />} />
        <Route path="/my-calendar" element={<MyCalendar />} />
        <Route path="/classes-calendar" element={<ClassesCalendar />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <AdminRoute>
              <Dashboard />
            </AdminRoute>
          }
        />
        <Route path="/profile" element={<MyAccount />} />
        <Route
          path="/all-users"
          element={
            <AdminRoute>
              <UserTable />
            </AdminRoute>
          }
        />
        <Route
          path="/user/:id"
          element={
            <AdminRoute>
              <SingleUser />
            </AdminRoute>
          }
        />
        <Route path="/all-categories" element={<Categories />} />
        <Route
          path="/statistics"
          element={
            <AdminRoute>
              <Statistics />
            </AdminRoute>
          }
        />
        <Route path="/user-statistics" element={<UserStatistics />} />
        <Route path="/comunications" element={<Comunications />} />
        <Route path="/weather" element={<Weather />} />
        <Route path="/emails" element={<Emails />} />
        <Route
          path="/table-of-trophy"
          element={
            <AdminRoute>
              <TableOfTrophy />
            </AdminRoute>
          }
        />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/mock-buttons" element={<MockButtons />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route
          path="*"
          element={
            <div className="page text-center" style={{ paddingTop: '4rem' }}>
              <h2>Página no encontrada</h2>
              <p>La página que buscas no existe.</p>
            </div>
          }
        />
      </Routes>
    </>
  )
}

export default App
